import { css } from '@linaria/core'

const styles = css`
  @apply h-full w-full flex justify-center items-center;
`

export default styles
